<template>
	<div class="webhooks_trace_app">
		<div class="sidebar2">
			<h2 class="caption">Request List <button @click="empty">Empty</button></h2>
			<ul>
				<li v-for="event in events" :key="event.id" @click="selectRequest(event)" :class="{ 'selected': event === selectedRequest }">
					<div class="minidetails"><small v-if="event.webhookDetails">{{ event.webhookDetails.name }}({{event.webhookDetails.id}})</small></div>
					<strong class="http-method">{{ event.request.method }}</strong> {{ event.request.url }}
					<br />
					<small>{{ formatRequestTime(event.requestTime) }}</small>
				</li>
			</ul>
		</div>
		<div class="main">
			<h1 class="caption">Request Details</h1>
			<div class="request-details" v-if="selectedRequest">
				<div class="minidetails"><b>Name:</b><small v-if="selectedRequest.webhookDetails">{{ selectedRequest.webhookDetails.name }} <b>ID:</b>({{selectedRequest.webhookDetails.id}})</small></div>
				<div class="details-part request">
					<h2 @click="toggleRequest">Request</h2>
					<div v-if="show.request">
						<div>
							<strong>Method:</strong> <span class="http-method">{{ selectedRequest.request.method }}</span>
						</div>
						<div>
							<strong>URI:</strong> {{ selectedRequest.request.url }}
						</div>
						<div>
							<strong>Request Time:</strong> {{ formatRequestTime(selectedRequest.requestTime) }}
						</div>
						<div>
							<strong>Request Headers:</strong> <div class="raw">{{ selectedRequest.request.headers }}</div>
						</div>
						<div>
							<strong>Request Body:</strong> <div class="raw">{{ selectedRequest.request.body }}</div>
						</div>
					</div>
				</div>
				<div class="details-part response">
					<h2 @click="toggleEvent">Internal event data</h2>
					<div v-if="show.event && selectedRequest.originalEvent">
						<strong>Data:</strong> <div class="raw">{{ selectedRequest.originalEvent }}</div>
					</div>
				</div>
				<div class="details-part response">
					<h2 @click="toggleResponse">Response</h2>
					<div v-if="show.response">
						<div v-if="selectedRequest.response">
							<div>
								<strong>Response Status:</strong> <div class="raw">{{ selectedRequest.response.status }}, {{ selectedRequest.response.statusText }}</div>
							</div>
							<div v-if="selectedRequest.response.status != 0">
								<strong>Response Headers:</strong> <div class="raw">{{ selectedRequest.response.headers }}</div>
							</div>
							<div v-if="selectedRequest.response.status != 0">
								<strong>Response Body:</strong> <div class="raw">{{ selectedRequest.response.body }}</div>
							</div>
						</div>
						<div v-else>
							<p>Response info is missing</p>
						</div>
					</div>
				</div>
			</div>
			<div v-else>
				<p>Select a request to view details.</p>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	data() {
		return {
			events: [],
			selectedRequest: null,
			show: {
				response: true,
				request: true,
				event: false
			}
		};
	},
	mounted() {
		let $injector = this.$root.angularInjector;
		const config = $injector.get("myConfig");
		const socketUrl = config.socketUrl;
		console.info(config);
		const socket = window.io(socketUrl, {
			transports: ["websocket"],
			query: {token: localStorage.token}
		});
		socket.emit("setWebhooksTraceListener");

		socket.on("newEvent", (event) => {
			this.events.push(event);
		});
	},
	methods: {
		selectRequest(event) {
			this.selectedRequest = event;
		},
		formatRequestTime(time) {
			return new Date(time).toLocaleString();
		},
		toggleResponse() {
			this.show.response = !this.show.response;
		},
		toggleRequest() {
			this.show.request = !this.show.request;
		},
		toggleEvent() {
			this.show.event = !this.show.event;
		},
		empty() {
			this.events = [];
			this.selectedRequest = null;
		}
	}
};
</script>

<style scoped>
.webhooks_trace_app {
	display: grid;
	grid-template-columns: 20% 1fr;
	height: 80vh;
}

.sidebar2 {
	/* padding: 20px; */
	background-color: #f2f2f2;
	overflow-x: auto;
}
.sidebar2 li {
	border-bottom: 1px solid #203a64;
	padding: 5px 3px;
	text-wrap: wrap;
	word-break: break-all;
	line-height: 1.3em;
}
.caption {
	position: sticky; top: 0;
	background-color: white;
	margin: 0;
	padding: 15px;
	color: #203a64;
}
.main {
	overflow-x: auto; margin-left: 5px; border-left: 5px solid #203a64;
}
.main .request-details {
	padding: 20px;

}
.main .request-details strong {
	margin: 5px 0;
	display: inline-block;
}
.raw {
	font-family: 'Courier New', Courier, monospace;
	white-space: pre;
	display: block;
	unicode-bidi: embed;
	background-color: white;
	padding: 15px;
	overflow-y: auto;
}

.selected {
  background-color: #e0e0e0;
}

.request-details h2 {
	box-shadow: 2px 2px 4px #7a7a95; padding: 5px; text-align: center;
	&:hover {
		cursor: pointer;
		background-color: #7a7a95;
		color: white;
		/* border-bottom: 2px dashed blue; */
	}
}

.details-part {
	padding: 0 10px;
	border: 1px solid black;
	box-shadow: 5px 5px 5px black;
}
.minidetails {
	.main & {padding: 5px; }
	background-color: #84d7ff;
}
.http-method {
	color: white; background-color: red; padding: 0 3px; font-weight: bold; font-family: monospace; border-radius: 3px;
}
</style>
